import { Columns, FormLayout, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import NotifySection from "../NotifySection/NotifySection.js";
import ActionField from "../ActionField.js";
import {
  PRODUCTS_ACTION_HIDE,
  PRODUCTS_ACTION_PUSH_DOWN,
  PRODUCTS_NO_ACTION
} from "../../../../../../../../../constants/productActionTypes.js";
import LowStockLevelField from "../LowStockLevelField.js";
import { useState } from "react";

const actionOptions = [
  { label: "Hide Low Stock", value: PRODUCTS_ACTION_HIDE },
  { label: "Push Down Low Stock", value: PRODUCTS_ACTION_PUSH_DOWN },
  { label: "No action", value: PRODUCTS_NO_ACTION }
];

const LowStockCard = () => {
  const [fieldTouched, setFieldTouched] = useState({ lowStockLevelFrom: false, lowStockLevelTo: false });

  const handleFieldTouch = (fieldName) => setFieldTouched((prev) => ({ ...prev, [fieldName]: true }));

  const showErrorAfterBothTouched = fieldTouched.lowStockLevelFrom && fieldTouched.lowStockLevelTo;

  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack distribution={"fill"} vertical>
            <FormLayout>
              <FormLayout.Group condensed title="Stock level ranges">
                <Field
                  name="lowStockLevelFrom"
                  component={LowStockLevelField}
                  prefix={"from"}
                  min={1}
                  showErrorAfterBothTouched={showErrorAfterBothTouched}
                  onBlur={() => handleFieldTouch("lowStockLevelFrom")}
                />
                <Field
                  name="lowStockLevelTo"
                  component={LowStockLevelField}
                  prefix={"to"}
                  min={1}
                  showErrorAfterBothTouched={showErrorAfterBothTouched}
                  onBlur={() => handleFieldTouch("lowStockLevelTo")}
                />
              </FormLayout.Group>
            </FormLayout>
            <Field name="lowStockAction" component={ActionField} options={actionOptions} />
            <Field name="lowStockNotify" component={NotifySection} />
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default LowStockCard;